import PlanTabs from "../components/PlanTabs";
import PlanCard from "../components/PlanCard";
import { familyBundles } from "../mock";

export default function PlansPage() {
  return (
    <main>
      <section className="bg-gradient-to-b from-green-50 to-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20 text-center">
          <p className="text-sm font-bold tracking-widest text-green-700">MEAL PLANS</p>
          <h1 className="mt-2 text-4xl md:text-5xl font-extrabold text-neutral-900">
            Build your meal plan
          </h1>
          <p className="mt-3 text-neutral-600 max-w-2xl mx-auto">
            Pick weekly or monthly. One-time payment, no auto-renewal. Cancel or pause anytime.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <PlanTabs />
      </section>

      <section className="bg-neutral-50 border-y border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="text-center">
            <p className="text-sm font-bold tracking-widest text-green-700">FAMILY BUNDLES</p>
            <h2 className="mt-2 text-3xl md:text-4xl font-extrabold text-neutral-900">Eat well together, save more</h2>
            <p className="mt-3 text-neutral-600">Minimum 2 people, same delivery address.</p>
          </div>
          <div className="mt-10 grid gap-6 md:grid-cols-3">
            {familyBundles.map((p) => (
              <PlanCard key={p.id} plan={p} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
